// extracted by mini-css-extract-plugin
module.exports = {"progress":"star-rating-average_progress__18gU2","stars":"star-rating-average_stars__3uDHF"};